import { render, staticRenderFns } from "./NewInfoItem.vue?vue&type=template&id=1ea05b6f&"
import script from "./NewInfoItem.vue?vue&type=script&lang=js&"
export * from "./NewInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports